<template>
  <div class="MyRank fs20">
    <div class="title fs26">决赛成绩信息</div>
    <div class="tb">
      <div v-for="(v, k) in info" class="column">
        <div class="t">{{keyMap[k]}}</div>
        <div>{{v}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Result',
   computed: {
     keyMap () {
       return {
         'realname': '姓名',
         'score': '分数',
         'wins': '胜场',
         'losses': '负场'
       }
     }
   },
   data () {
     return {
       info: []
     }
   },
   mounted() {
     this.$http.get("/api/rank/me?round=" + "2019-3")
         .then(res => {
           this.info = {
             'realname': res.data.realname,
             'score': res.data.score,
             'wins': res.data.wins,
             'losses': res.data.losses,
           }
     })
   }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .MyRank{
   /* background-image: url(~@/assets/image/score/bg-myrank.png); */
   background-size: 62.3vw;
   width: 62.3vw;
   height: 10.73vw;
   margin-left: auto;
   margin-right: auto;
   margin-top: 2.3vw;
   margin-bottom: 2vw;
   padding-top: 1.1vw;
   display:flex;
   flex-direction: column;
   align-items:center;
   box-sizing: border-box;
   /* color: white; */
 }
 .tb{
   /* margin-left: 12.35vw;
      margin-right: 5.5vw; */
   width: 60%;
   display: flex;
   height: 6.5vw;
 }
 .title{

   font-weight: bold;
   margin-bottom: 2em;
 }
 .column{
   flex-grow: 1;
   max-width: 10.99vw;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: space-around;
   border-right: 1px solid black;
 }
 .column:first-child{
   border-left: 1px solid black;
 }
 .column > div:first-child{
   border-top: 1px solid black;
 }
 .column > div {
   flex-basis: 50%;
   width: 100%;
   border-bottom: 1px solid black;
   display: flex;
   align-items:center;
   justify-content: center;
 }
 .t{
   background-color: var(--blue);
   color: white;
 }
</style>
